import {
  createFrontendPlugin,
  ApiBlueprint,
  fetchApiRef,
  configApiRef,
  discoveryApiRef,
  ExtensionDefinition,
} from '@backstage/frontend-plugin-api';
import { EntityContentBlueprint } from '@backstage/plugin-catalog-react/alpha';
import { EntityCardBlueprint } from '@backstage/plugin-catalog-react/alpha';
import { b2cApiRef } from '@internal/backstage-plugin-b2c-common';
import { B2CApiImpl } from './b2cApiImpl';
import { Entity } from '@backstage/catalog-model';

const b2cApi = ApiBlueprint.make({
  params: defineParams =>
    defineParams({
      api: b2cApiRef,
      deps: {
        fetchApi: fetchApiRef,
        configApi: configApiRef,
        discoveryApi: discoveryApiRef,
      },
      factory: ({ fetchApi, configApi, discoveryApi }) => new B2CApiImpl({
        fetchApi,
        configApi,
        discoveryApi,
      }),
    }),
});

export const B2C_ANNOTATION = 'simcorp.com/b2c';

export function isB2C(entity: Entity) {
  const metadata = entity.metadata;
  return metadata.name === 'b2cservice' || Boolean(metadata.annotations?.[B2C_ANNOTATION]);
}

export const entityB2CTenantCard: ExtensionDefinition = EntityCardBlueprint.make({
  name: 'entity-b2c-tenant-card',
  params: {
    loader: () => import('./components/B2CTenantCard').then(m => <m.B2CTenantCard />),
    filter: isB2C,
  }
});

export const entityRedirectUriContent: ExtensionDefinition = EntityContentBlueprint.make({
  name: 'entity-redirect-uri',
  params: {
    path: '/redirect-uris',
    title: 'Redirect URIs',
    loader: () => import('./components/RedirectUriContent').then(m => <m.RedirectUriContent />),
    filter: isB2C,
  }
});

export const entityIdpContent: ExtensionDefinition = EntityContentBlueprint.make({
  name: 'entity-idp',
  params: {
    path: '/idp-config',
    title: 'IdP Configuration',
    loader: () => import('./components/IdpContent').then(m => <m.IdpContent />),
    filter: isB2C,
  }
});

export const entityScIdpRolesContent: ExtensionDefinition = EntityContentBlueprint.make({
  name: 'entity-sc-idp-roles',
  params: {
    path: 'sc-idp-roles',
    title: 'SimCorp IdP Roles',
    loader: () => import('./components/ScIdpRolesContent').then(m => <m.ScIdpRolesContent />),
    filter: isB2C,
  }
});

export const entityUpstreamClusterContent: ExtensionDefinition = EntityContentBlueprint.make({
  name: 'entity-upstream-cluster',
  params: {
    path: '/ingress',
    title: 'Ingress',
    loader: () => import('./components/UpstreamClusterContent').then(m => <m.UpstreamClusterContent />),
    filter: isB2C,
  }
});

export const authorizedTenantsAndSystemsContent: ExtensionDefinition = EntityContentBlueprint.make({
  name: 'authorized-tenants-and-systems',
  params: {
    path: '/authorized-systems',
    title: 'System Authorizations',
    loader: () => import('./components/AuthorizedTenantsAndSystemsContent').then(m => <m.AuthorizedTenantsAndSystemsContent />),
    filter: isB2C,
  }
});

export const b2cFrontendPlugin = createFrontendPlugin({
  pluginId: 'b2c-frontend',
  extensions: [
    b2cApi,
    entityIdpContent,
    entityUpstreamClusterContent,
    entityScIdpRolesContent,
    entityRedirectUriContent,
    authorizedTenantsAndSystemsContent,
    entityB2CTenantCard,
  ],
});
